import { document } from './role'

export const queries = {
  document,
}
export default queries
